import styled from 'styled-components'

import { CostSummaryRowStyled } from './CostSummaryRowStyled'
import { CostSummaryTotalRowStyled } from './CostSummaryTotalRowStyled'
import { type ICostSummaryProps } from '../CostSummary'

interface ICostSummaryStyledProps extends ICostSummaryProps {}

export const CostSummaryStyled = styled.table<ICostSummaryStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  display: grid;

  grid-template-columns: auto auto;

  grid-column-gap: ${(props) =>
    props.theme.typography.pxToRem(props.compact ? 24 : 64)};
  row-gap: ${(props) => props.theme.typography.pxToRem(8)};

  position: relative;

  > tbody {
    display: contents;
  }

  ${CostSummaryRowStyled} + ${CostSummaryTotalRowStyled} {
    td,
    th {
      padding-top: ${(props) => props.theme.typography.pxToRem(8)};
    }

    > th:before {
      content: '';
      display: block;

      position: absolute;
      left: 0;
      right: 0;
      margin-top: ${(props) => props.theme.typography.pxToRem(-8)};
      background-color: ${(props) => props.theme.colors.content.border};
      height: 1px; /* stylelint-disable-line */
    }
  }
`
